export const useTranslateSortLabel = () => {
  const { t } = useI18n();

  return (type: string, from: string, to: string) => {
    const typeLabel = t(`sort.type.${type}`);
    const fromLabel = t(`sort.options.${from}`);
    const toLabel = t(`sort.options.${to}`);

    return `${typeLabel} ${fromLabel} - ${toLabel}`;
  };
};
